import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export function useResizeObserver(
    target: React.RefObject<HTMLDivElement>,
    resizeObserverCallback: (bounds: DOMRectReadOnly) => void
) {
    React.useEffect(() => {
        if (target.current) {
            const resizeObserver = new ResizeObserver(([entry]: ResizeObserverEntry[]) => {
                resizeObserverCallback(entry.contentRect as DOMRectReadOnly);
            });

            resizeObserver.observe(target.current);

            const { width, height } = target.current.getBoundingClientRect();
            resizeObserverCallback({
                top: 0,
                left: 0,
                x: 0,
                y: 0,
                bottom: height,
                height,
                right: width,
                width,
            } as DOMRectReadOnly);

            return () => resizeObserver.disconnect();
        }
        return undefined;
    }, [target.current, resizeObserverCallback]);
}
